import { FC } from 'react';
import { BaseAppCard } from './base-app-card';
import { ReactComponent as HubspotLogo } from '../../../../../components/icons/hubspot-logo.svg';
interface HubspotAuthCardProps {
    isActive: boolean;
    isConnected: boolean;
    isLoading: boolean;
    onConnect: () => void;
    onDisconnect?: () => void;
}

export const HubspotAuthCard: FC<HubspotAuthCardProps> = ({
    isActive,
    isConnected,
    isLoading,
    onConnect,
    onDisconnect,
}) => {
    const handleConnect = () => {
        window.open(import.meta.env.VITE_HUBSPOT_AUTHENTICATION_URI, '_blank');
    };

    return (
        <BaseAppCard
            title="Hubspot"
            showTitle={true}
            description="Sync Hubspot with Andsend"
            appId="hubspot"
            bgColor="bg-orange-50"
            icon={<HubspotLogo className="object-contain" />}
            isConnected={isConnected}
            isActive={isActive}
            handleConnect={handleConnect}
            // onDisconnect={onDisconnect}
            isLoading={isLoading}
            connectButtonText="Connect Hubspot"
            connectedText="Your Hubspot account is connected."
            notConnectedText="Connect your Hubspot account to sync contacts, accounts, and deals."
        />
    );
};
